import updateSharedCalendarsInitialState from '../data/mutators/updateSharedCalendarsInitialState';
import loadSharedCalendarsConfiguration from '../services/loadSharedCalendarsConfiguration';
import parseCalendarFoldersResponse from '../utils/parseCalendarFoldersResponse';
import { PerformanceDatapoint } from 'owa-analytics';
import { DatapointStatus } from 'owa-analytics/lib/types/DatapointEnums';
import { trace } from 'owa-trace';
import {
    lazyInitializeCalendarPublishingPermissionStore,
    lazyLoadAllCalendarPublishingPermissions,
    lazySetCalendarPublishingErrorStateError,
    CalendarPublishingError,
} from 'owa-calendar-sharing';

/**
 * 1. Gets the calendar folder and groups data from the server
 * 2. Parses the data to get the initial state of the shared calendars
 * 3. Calls an action to update the store with the parsed data
 * 4. For each calendar loads the publish info
 */
export default async function initSharedCalendarsConfiguration() {
    try {
        var dataPoint = new PerformanceDatapoint('InitSharedCalendarsOption');
        let calendarFoldersResponse = await loadSharedCalendarsConfiguration();
        await lazyInitializeCalendarPublishingPermissionStore.importAndExecute();

        lazySetCalendarPublishingErrorStateError.importAndExecute(null); // Reset publishing error

        if (
            calendarFoldersResponse.CalendarFolders?.length &&
            calendarFoldersResponse.CalendarGroups &&
            calendarFoldersResponse.CalendarGroups.length
        ) {
            dataPoint.end();
            let initialViewState = parseCalendarFoldersResponse(calendarFoldersResponse);
            updateSharedCalendarsInitialState(initialViewState);
            initialViewState.calendarsPublish &&
                lazyLoadAllCalendarPublishingPermissions.importAndExecute(
                    initialViewState.calendarsPublish
                );
            return true;
        } else {
            lazySetCalendarPublishingErrorStateError.importAndExecute(
                CalendarPublishingError.InitialLoadFailure
            );
            dataPoint.endWithError(
                DatapointStatus.ServerError,
                new Error('Request returned empty response')
            );
            return false;
        }
    } catch (e) {
        lazySetCalendarPublishingErrorStateError.importAndExecute(
            CalendarPublishingError.InitialLoadFailure
        );
        dataPoint.endWithError(DatapointStatus.RequestNotComplete, new Error('Request failed'));
        trace.warn(e.message || 'initSharedCalendarsConfiguration failed');
        return false;
    }
}
